<template>
  <Multiselect
    v-model="value"
    :options="options"
    :label="label"
    :icon="icon"
    :error="error"
    :dark="dark"
    :required="required"
    :multiple="false"
    :disabled="disabled"
    :pills="pills"
  />
</template>

<script lang="ts" setup>
type Option = { value: any; label: string }

withDefaults(
  defineProps<{
    modelValue?: any
    options: Option[]
    label: string
    icon?: 'string'
    error?: string | boolean
    dark?: boolean
    required?: boolean
    pills?: boolean
    disabled?: boolean
  }>(),
  {
    iconClasses: 'w-5 mx-2',
    dark: false,
    required: true,
    pills: false,
    disabled: false,
  }
)

const value = defineModel<any>()
</script>
